import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { resourceDetailsCostsCostTypeSelector } from "@/store/resource-details/selectors/options/resourceDetailsCostsCostTypeSelector";
import { CostType } from "@/services/cloudchipr.api";
import { setResourceDetailsCostType } from "@/store/resource-details/resourceDetailsSlice";
import { getResourceDetailsResourceBillingDataThunk } from "@/store/resource-details/thunks/data/getResourceDetailsResourceBillingDataThunk";
import { CostTypeSelect } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/CostTypeSelect";
import { resourceDetailsTargetResourceProviderSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceProviderSelector";

export const ResourceDetailsCostTypeSelect: FC = () => {
  const dispatch = useAppDispatch();
  const costType = useAppSelector(resourceDetailsCostsCostTypeSelector);
  const provider = useAppSelector(
    resourceDetailsTargetResourceProviderSelector,
  );

  const changeHandler = useCallback(
    (costType: CostType) => {
      dispatch(setResourceDetailsCostType(costType));
      dispatch(getResourceDetailsResourceBillingDataThunk());
    },
    [dispatch],
  );

  if (provider !== "aws" && provider !== "azure") {
    return null;
  }

  return (
    <CostTypeSelect
      size="small"
      workFor={provider}
      costType={costType}
      onCostTypeChange={changeHandler}
    />
  );
};
